const phoneNumber = () => null;

export default phoneNumber;
